export function convertToUserTime(utcTime: string, timezone?: string | null) {
  if (!utcTime) { return ""; }
  const timeZone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeWithOffset = new Date(utcTime)
    .toLocaleString('ru-RU', { timeZone, timeZoneName: 'shortOffset' })
    .replace(',', '');
  return `${timeWithOffset} (${timeZone})`;
};
